/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Usage kind.   (german: Verwendungszweck)     * `Private`             - private purposes only (german: privat)   * `Business`            - business purposes only (german: geschäftlich)   * `BusinessAndPrivate`  - private and business purposes (german: privat und geschäftlich)
 */
export const UsageKind = {
  Private: 'Private',
  Business: 'Business',
  BusinessAndPrivate: 'BusinessAndPrivate',
} as const;
export type UsageKind = (typeof UsageKind)[keyof typeof UsageKind];
